import { useState, useEffect, useCallback } from 'react';

export const useShowMapEvent = (
	paramName = 'showMap',
	defaultValue = false
) => {
	const readParam = useCallback(() => {
		if (typeof window === 'undefined') return defaultValue;

		const params = new URLSearchParams(window.location.search);
		const value = params.get(paramName);

		return value ? value === 'true' : defaultValue;
	}, [paramName, defaultValue]);

	const [showMap, setShowMap] = useState(defaultValue);

	useEffect(() => {
		// Initialize with actual URL value
		setShowMap(readParam());

		const update = () => setShowMap(readParam());

		// 1. Custom event from toggle button (ws-locations-control widget)
		window.addEventListener('showMapChange', update);

		// 2. Browser back/forward navigation
		window.addEventListener('popstate', update);

		return () => {
			window.removeEventListener('showMapChange', update);
			window.removeEventListener('popstate', update);
		};
	}, [readParam]);

	return showMap;
};
